import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

type Props = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Fullscreen(props: Props) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="Fullscreen"
      style={style}
    >
      <path d="M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z" />
    </svg>
  )
}
